export type PopupAnchor =
  | 'top'
  | 'bottom'
  | 'top-left'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-right';

export type PopupPlacement = { anchor: PopupAnchor; offset: number };

export const POPUP_MARGIN = 24;
export const POPUP_OFFSET = 20;

export function getPopupSize(expanded: boolean) {
  return {
    cardWidth: expanded ? 380 : 200,
    cardHeight: expanded ? 340 : 170,
  };
}

export function getPopupPlacementForPoint(
  point: { x: number; y: number },
  expanded: boolean,
): PopupPlacement {
  const { cardWidth, cardHeight } = getPopupSize(expanded);
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const topSpace = point.y - POPUP_MARGIN;
  const bottomSpace = viewportHeight - point.y - POPUP_MARGIN;
  const nearLeft = point.x < cardWidth / 2 + POPUP_MARGIN;
  const nearRight = point.x > viewportWidth - (cardWidth / 2 + POPUP_MARGIN);

  const preferBottom = topSpace >= cardHeight || topSpace >= bottomSpace;
  let anchor: PopupAnchor = preferBottom ? 'bottom' : 'top';

  if (nearLeft) {
    anchor = preferBottom ? 'bottom-left' : 'top-left';
  } else if (nearRight) {
    anchor = preferBottom ? 'bottom-right' : 'top-right';
  }

  return { anchor, offset: POPUP_OFFSET };
}

export function getViewportPointForOffset(offset: [number, number]) {
  return {
    x: window.innerWidth / 2 + offset[0],
    y: window.innerHeight / 2 + offset[1],
  };
}

export function getDesktopFocusOffset(expanded: boolean): [number, number] {
  const { cardHeight } = getPopupSize(expanded);
  const viewportHeight = window.innerHeight;
  const lowerScreenTarget = viewportHeight * 0.68;
  const cardCompensatedTarget = viewportHeight / 2 + cardHeight * 0.3 + POPUP_MARGIN;
  const desiredPointY = Math.min(
    viewportHeight - 120,
    Math.max(lowerScreenTarget, cardCompensatedTarget, cardHeight + POPUP_MARGIN),
  );

  return [0, Math.round(desiredPointY - viewportHeight / 2)];
}
